import {
  ColumnWidthOutlined,
  CopyOutlined, DeleteOutlined,
  EditOutlined, FileAddOutlined, LockOutlined, PlusOutlined, ProfileOutlined, UnlockOutlined,
  RedoOutlined, UndoOutlined,
  VerticalAlignMiddleOutlined
} from '@ant-design/icons';
import { ColorPicker, FloatButton, Popover, Tooltip } from 'antd';
import AlignItemsContent from './Content/AlignItemsContent';
import GridIcon from '../../../../Icons/GridIcon';
import AddItemsContent from './Content/AddItemsContent';
import AddGridIcon from '../../../../Icons/AddGridIcon';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { blue, presetPalettes} from '@ant-design/colors';
import BendItemsContent from './Content/BendItemsContent';
import BendIcon from '../../../../Icons/BendIcon';
import FlipIcon from '@mui/icons-material/Flip';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import Rotate90DegreesCwIcon from '@mui/icons-material/Rotate90DegreesCw';
import Rotate90DegreesCcwIcon from '@mui/icons-material/Rotate90DegreesCcw';

const EditToolbar = (props) => {
  const [open, setOpen] = useState(false);
  const collapsed = useSelector((state) => state.sidebar.isCollapsed);

  const genPresets = (presets = presetPalettes) =>
    Object.entries(presets).map(([label, colors]) => ({
      label,
      colors,
    }));

  const presets = genPresets({blue});

  return (
    <FloatButton.Group
      disabled={props.isLocked}
      icon={<EditOutlined/>}
      open={open}
      shape="square"
      trigger="click"
      placement="right"
      className="toolbar"
      style={{
        marginTop: "7.5px",
        marginLeft: collapsed ? "80px" : "220px",
        transition: "margin-left 0.25s ease"
      }}
      onClick={() => setOpen(!open)}
    >
      <Tooltip placement="bottom" title="Bild hochladen">
        <FloatButton icon={<AddPhotoAlternateIcon/>} onClick={props.handleButtonClick}/>
      </Tooltip>
      {props.hasBackgroundImage && (
        <Tooltip placement="bottom" title={props.bgLocked ? "Hintergrundbild entsperren" : "Hintergrundbild sperren"}>
          <FloatButton
            icon={props.bgLocked ? <LockOutlined /> : <UnlockOutlined />}
            type={props.bgLocked ? 'default' : 'primary'}
            onClick={props.toggleBgLocked}
          />
        </Tooltip>
      )}
      <Tooltip placement="bottom" title="Stuhl hinzufügen">
        <FloatButton icon={<PlusOutlined />} onClick={() => props.addShape('rectangle')}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Farbe">
        <FloatButton
          icon={<ColorPicker presets={presets} onChange={props.colorChange} size="small" defaultValue={props.color}/>}/>
      </Tooltip>
      <Popover
        content={<AddItemsContent gapX={props.gapAddX} setGapX={props.setGapAddX} gapY={props.gapAddY} setGapY={props.setGapAddY} rows={props.rows} setRows={props.setRows} cols={props.cols} setCols={props.setCols} />}
        trigger="hover"
        placement="bottom"
        overlayStyle={{minWidth: 225, height: 150}}
        title="Stühle hinzufügen">
        <FloatButton icon={<AddGridIcon/>} onClick={props.addItemsInGrid} />
      </Popover>
      <Tooltip placement="bottom" title="Stühle in Raster ausrichten">
        <FloatButton icon={<GridIcon />} onClick={props.alignShapesInGrid} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Popover
        content={<AlignItemsContent scaleShapesInX={props.scaleShapesInX} scaleShapesInY={props.scaleShapesInY} gapX={props.gapX} setGapX={props.setGapX} gapY={props.gapY} setGapY={props.setGapY} maxElements={props.maxElements} setMaxElements={props.setMaxElements} />}
        trigger="hover"
        placement="bottom"
        overlayStyle={{minWidth: 200, height: 150}}
        title="Stuhlabstand">
        <FloatButton icon={<ColumnWidthOutlined/>} disabled={true}/>
      </Popover>
      <Tooltip placement="bottom" title="Horizontal ausrichten">
        <FloatButton icon={<VerticalAlignMiddleOutlined />} onClick={props.centerShapesHorizontally} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Vertikal ausrichten">
        <FloatButton icon={<VerticalAlignMiddleOutlined rotate={90} />} onClick={props.centerShapesVertically} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Rotieren 90° (rechts)">
        <FloatButton icon={<Rotate90DegreesCwIcon />} onClick={() => props.rotateSelection("left")} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Rotieren 90° (links)">
        <FloatButton icon={<Rotate90DegreesCcwIcon />} onClick={() => props.rotateSelection("right")} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Spiegeln">
        <FloatButton icon={<FlipIcon />} onClick={props.mirrorSelection} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Popover
        content={<BendItemsContent handleStraightenShapes={props.handleStraightenShapes} setBendMode={props.setBendMode}/>}
        trigger="hover"
        placement="bottom"
        overlayStyle={{minWidth: 200, height: 150}}
        title="Auswahl biegen">
        <FloatButton icon={<BendIcon/>} disabled={props.selectedIds.length === 0}/>
      </Popover>

      <Tooltip placement="bottom" title="Kopieren (Ctrl + C)">
        <FloatButton icon={<CopyOutlined/>} onClick={props.duplicateShapes} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Einfügen (Ctrl + V)">
        <FloatButton icon={<FileAddOutlined/>} onClick={props.pasteShapes} disabled={props.clipboard.length === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Alle auswählen (Ctrl + A)">
        <FloatButton icon={<ProfileOutlined/>} onClick={() => props.markAll()}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Rückgängig (Ctrl + Z)">
        <FloatButton icon={<UndoOutlined/>} onClick={props.handleUndo} disabled={props.historyStep === 0}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Wiederherstellen (Ctrl + Y)">
        <FloatButton icon={<RedoOutlined/>} onClick={props.handleRedo} disabled={props.historyStep === props.history.length - 1}/>
      </Tooltip>
      <Tooltip placement="bottom" title="Löschen">
        <FloatButton icon={<DeleteOutlined/>} onClick={props.deleteSelectedShapes} disabled={props.selectedIds.length === 0}/>
      </Tooltip>
    </FloatButton.Group>
  )
}

export default EditToolbar
